import dayjs from 'dayjs';
import 'dayjs/locale/da';
import {DefaultTimelineMetadata} from './types';
import now from "./now.ts";

const MAX_DATE = '9999-12-31';

export function getCurrentDateTime(): string {
    return dayjs().format('YYYY-MM-DD HH:mm:ss');
}

export function isDateSame(date: string): boolean {
    return now.isSame(date, 'day');
}

export function isDateAfter(date: string): boolean {
    return now.isAfter(date, 'day');
}

export function isDateSameOrAfter(date: string): boolean {
    return isDateSame(date) || isDateAfter(date);
}

export function isDateBefore(date: string): boolean {
    return now.isBefore(date, 'day');
}

export function isPastDays(date: string, days: number): boolean {
    return now.isAfter(dayjs(date).add(days, 'day'));
}

export function isPastMinutes(date: string, minutes: number): boolean {
    return dayjs().isAfter(dayjs(date).add(minutes, 'minute'));
}

export function isDateMaxDate(date: string): boolean {
    return dayjs(date).isSame(dayjs(MAX_DATE));
}

export function dateCompare(date1: string, date2: string): number {
    if (date1 === date2) {
        return 0;
    }
    if (date1 < date2) {
        return -1;
    }

    return 1;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function findMetadata(key: string, metadata: DefaultTimelineMetadata[]): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return metadata.find((metadata: any) => metadata.key === key)?.value;
}


export const shouldShowWinterHolidayWarning = () => {
    const mondayDay = 0
    const januaryMonth = 0
    const decemberMonth = 11
    return (now.month() === decemberMonth || (now.month() === januaryMonth && now.day() === mondayDay))
}

export const shouldShowPayerDayWarning = () => {
    const prayerDay = 5
    const juneMonth = 5
    return now.month() === juneMonth && now.day() <= prayerDay
}
